import { render } from "./FranchiseProcess.vue?vue&type=template&id=1d4eeeed&scoped=true&ts=true"
import script from "./FranchiseProcess.vue?vue&type=script&lang=ts"
export * from "./FranchiseProcess.vue?vue&type=script&lang=ts"

import "./FranchiseProcess.vue?vue&type=style&index=0&id=1d4eeeed&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d4eeeed"]])

export default __exports__